module.exports = __webpack_public_path__ + "img/211.69d1ffca.jpg";